import { render, staticRenderFns } from "./NzTermsAndConditionsContent.vue?vue&type=template&id=39804c6d"
import script from "./NzTermsAndConditionsContent.vue?vue&type=script&lang=js"
export * from "./NzTermsAndConditionsContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports